/* eslint-disable */
import React from 'react';

const EditorPreviewSwaggerUIWrapper = (Original, system) => {
  const EditorPreviewWithMockButton = (props) => {
    const { getComponent } = props;
    const MockButtonInjector = getComponent('MockButtonInjector', true);

    return (
      <div>
        <Original {...props} />
        {MockButtonInjector && (
          <MockButtonInjector
            specSelectors={system.specSelectors}
            getSystem={() => system}
            backendSpecsActions={system.backendSpecsActions}
            backendSpecsSelectors={system.backendSpecsSelectors}
          />
        )}
      </div>
    );
  };

  return EditorPreviewWithMockButton;
};

export default EditorPreviewSwaggerUIWrapper;